import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { isSessionStorageAvailable } from './sessionStorageHelper';
import { ROUTE_KEYS } from 'legacyfrontend/constants';
export const withSessionStorageCheck = (WrappedComponent) => {
  return function WithSessionStorageCheck(props) {
    const history = useHistory();

    useEffect(() => {
      if (!isSessionStorageAvailable()) {
        history.push(ROUTE_KEYS.HOME);
      }
    }, [history]);

    return <WrappedComponent {...props} />;
  };
};
